import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'core/store';

const agendaOpportunitiesReducer = (state: RootState) => state.private.agendaOpportunities;

export const opportunitiesSelector = createSelector(
  agendaOpportunitiesReducer,
  (s) => s.opportunities
);

export const opportunitiesPagingSelector = createSelector(
  agendaOpportunitiesReducer,
  (s) => s.paging
);

export const filtersOpportunitiesUsedSelector = createSelector(
  agendaOpportunitiesReducer,
  (s) => s.filtersUsed
);
